var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.users.length)?_c('v-row',[_c('v-col',[_c('v-btn',{staticClass:"primary",attrs:{"disabled":_vm.noMore},on:{"click":_vm.loadMore}},[_vm._v(_vm._s(_vm.buttonText))])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }